import React from 'react';
import { Box, Typography, Stack } from '@mui/material';
import { HeroType, HeroVideo } from '../../types';
import { VideoItem } from '../VideoCarousel/VideoCarouselModal';
import { HeroTypeToggle } from './HeroTypeToggle';
import { HeroImageInput } from './HeroImageInput';
import { HeroVideoContent } from './HeroVideoContent';
import { HeroInfoBox } from './HeroInfoBox';

interface HeroContentSectionProps {
  teamAbbrv: string;
  heroType: HeroType;
  heroImage: string;
  heroVideo: HeroVideo | null;
  heroVideoSearchQuery: string;
  heroVideoSearchResults: VideoItem[];
  isSearchingHeroVideo: boolean;
  isPreviewPlaying: boolean;
  actualVideoDuration: number | null;
  videoRef: React.RefObject<HTMLVideoElement>;
  videoUrl: string;
  onHeroTypeChange: (type: HeroType) => void;
  onHeroImageChange: (value: string) => void;
  onHeroVideoSearchQueryChange: (query: string) => void;
  onSelectHeroVideo: (video: VideoItem) => void;
  onRemoveHeroVideo: () => void;
  onPausePreview: () => void;
  onPlayPreview: () => void;
  onLoopRangeChange: (event: Event, newValue: number | number[]) => void;
  onVideoTimeUpdate: () => void;
  onLoadedMetadata: () => void;
  onEnded: () => void;
  getEffectiveDuration: () => number;
}

export function HeroContentSection({
  teamAbbrv,
  heroType,
  heroImage,
  heroVideo,
  heroVideoSearchQuery,
  heroVideoSearchResults,
  isSearchingHeroVideo,
  isPreviewPlaying,
  actualVideoDuration,
  videoRef,
  videoUrl,
  onHeroTypeChange,
  onHeroImageChange,
  onHeroVideoSearchQueryChange,
  onSelectHeroVideo,
  onRemoveHeroVideo,
  onPausePreview,
  onPlayPreview,
  onLoopRangeChange,
  onVideoTimeUpdate,
  onLoadedMetadata,
  onEnded,
  getEffectiveDuration,
}: HeroContentSectionProps) {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 600 }}>
        Hero-innehåll
      </Typography>
      <Stack direction="row" spacing={4}>
        <Box sx={{ flex: 1 }}>
          <HeroTypeToggle value={heroType} onChange={onHeroTypeChange} />
          {heroType === 'image' ? (
            <HeroImageInput teamAbbrv={teamAbbrv} value={heroImage} onChange={onHeroImageChange} />
          ) : (
            <HeroVideoContent
              heroVideo={heroVideo}
              heroVideoSearchQuery={heroVideoSearchQuery}
              heroVideoSearchResults={heroVideoSearchResults}
              isSearchingHeroVideo={isSearchingHeroVideo}
              isPreviewPlaying={isPreviewPlaying}
              actualVideoDuration={actualVideoDuration}
              videoRef={videoRef}
              videoUrl={videoUrl}
              onSearchQueryChange={onHeroVideoSearchQueryChange}
              onSelectVideo={onSelectHeroVideo}
              onRemove={onRemoveHeroVideo}
              onPausePreview={onPausePreview}
              onPlayPreview={onPlayPreview}
              onLoopRangeChange={onLoopRangeChange}
              onVideoTimeUpdate={onVideoTimeUpdate}
              onLoadedMetadata={onLoadedMetadata}
              onEnded={onEnded}
              getEffectiveDuration={getEffectiveDuration}
            />
          )}
        </Box>
        <HeroInfoBox heroType={heroType} />
      </Stack>
    </Box>
  );
}
